var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "(lc) logos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3315 0.138672H7.62115C7.62115 2.05511 9.18104 3.615 11.0975 3.615H12.5237V4.97433C12.5237 6.89076 14.0835 8.45065 16 8.45065V0.807196C16 0.428365 15.688 0.138672 15.3315 0.138672Z",
    fill: "#0082FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5209 3.97266H3.81061C3.81061 5.88909 5.3705 7.44898 7.28693 7.44898H8.71311V8.83059C8.71311 10.747 10.273 12.3069 12.1894 12.3069V4.66346C12.1894 4.28463 11.8775 3.97266 11.5209 3.97266Z",
    fill: "url(#paint0_linear_926_49873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.71031 7.80469H0C0 9.72112 1.55989 11.281 3.47632 11.281H4.88022V12.6403C4.88022 14.5568 6.44011 16.1167 8.35655 16.1167V8.45093C8.37883 8.11666 8.06685 7.80469 7.71031 7.80469Z",
    fill: "url(#paint1_linear_926_49873)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_926_49873",
    x1: 12.0223,
    y1: 3.99271,
    x2: 8.74431,
    y2: 7.37321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0050D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_926_49873",
    x1: 8.41448,
    y1: 7.84034,
    x2: 4.62396,
    y2: 11.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0050D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraLogo);
export default __webpack_public_path__ + "static/media/jira_logo.06be8f5178741bd1312284c6b03e5b79.svg";
export { ForwardRef as ReactComponent };